import { formatCurrency } from '@susu/currency'

export function formatPrice(
  amount: number,
  currencyCode: string,
  fractionDigits = 2,
): string {
  return formatCurrency(amount, currencyCode, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    useGrouping: true,
  })
}
